import { Editor } from '@tiptap/react'
import { Button, Tooltip } from 'antd'
import { Minus } from 'iconsax-react'
import { useTranslation } from 'react-i18next'

type Props = {
  editor: Editor
}

export const HorizontalRuleButton = ({ editor }: Props) => {
  const { t } = useTranslation()

  const onInsertHorizontalRule = () => {
    editor.chain().focus().setHorizontalRule().run()
  }

  return (
    <Tooltip title={t('editor.horizontal_line')}>
      <Button icon={<Minus size={14} />} onClick={onInsertHorizontalRule} />
    </Tooltip>
  )
}
